document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.custom-gallery .wp-block-image > a').forEach(a => {
		if (!a.hasAttribute('data-lightbox')) {
			a.setAttribute('data-lightbox', 'gallery');
		}
	});
});
